/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllPalReauthCaseManagersResponse } from './FindAllPalReauthCaseManagersResponse';
import {
    FindAllPalReauthCaseManagersResponseFromJSON,
    FindAllPalReauthCaseManagersResponseFromJSONTyped,
    FindAllPalReauthCaseManagersResponseToJSON,
    FindAllPalReauthCaseManagersResponseToJSONTyped,
} from './FindAllPalReauthCaseManagersResponse';

/**
 * 
 * @export
 * @interface FindAllPalReauthCaseManagers200Response
 */
export interface FindAllPalReauthCaseManagers200Response {
    /**
     * 
     */
    data?: FindAllPalReauthCaseManagersResponse;
}

/**
 * Check if a given object implements the FindAllPalReauthCaseManagers200Response interface.
 */
export function instanceOfFindAllPalReauthCaseManagers200Response(value: object): value is FindAllPalReauthCaseManagers200Response {
    return true;
}

export function FindAllPalReauthCaseManagers200ResponseFromJSON(json: any): FindAllPalReauthCaseManagers200Response {
    return FindAllPalReauthCaseManagers200ResponseFromJSONTyped(json, false);
}

export function FindAllPalReauthCaseManagers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalReauthCaseManagers200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllPalReauthCaseManagersResponseFromJSON(json['data']),
    };
}

export function FindAllPalReauthCaseManagers200ResponseToJSON(json: any): FindAllPalReauthCaseManagers200Response {
    return FindAllPalReauthCaseManagers200ResponseToJSONTyped(json, false);
}

export function FindAllPalReauthCaseManagers200ResponseToJSONTyped(value?: FindAllPalReauthCaseManagers200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllPalReauthCaseManagersResponseToJSON(value['data']),
    };
}

